import fields from '@/sui/data/sheets/edit/fields'
import common from '@/sui/data/sheets/convert/common'

function build (v) {
  const c = [
    { field: fields.immuno },
    { field: fields.cancer },
    { field: fields.origin, cfield: fields.neoOrigin },
    { field: fields.dead }
  ]

  const fv = {
    v1: [
      { field: fields.future },
      { field: fields.unitType, special: 'unitType' },
      {
        field: fields.bacteremia,
        cfield: fields.bacteremia,
        object: common.bacteremia.v1
      }
    ],

    v2: [
      ...c,
      { field: fields.unitType, special: 'unitType' },
      {
        field: fields.bacteremia,
        cfield: fields.bacteremia,
        object: common.bacteremia.v2
      }
    ],

    v3: [
      ...c,
      { field: fields.unitType, special: 'unitType' },
      {
        field: fields.bacteremia,
        cfield: fields.bacteremia,
        object: common.bacteremia.v3
      }
    ],

    v4: [
      ...c,
      { field: fields.unitType, special: 'unitType' },
      { field: fields.bmi, special: 'numeric' },
      {
        field: fields.bacteremia,
        cfield: fields.bacteremia,
        object: common.bacteremia.v4
      }
    ],

    v5: [
      ...c,
      { field: fields.unitType, special: 'unitType_v2' },
      { field: fields.bmi, special: 'numeric' },
      {
        field: fields.bacteremia,
        cfield: fields.bacteremia,
        object: common.bacteremia.v5
      }
    ],

    v6: [
      ...c,
      { field: fields.unitType, special: 'unitType_v2' },
      { field: fields.bmi, special: 'numeric' },
      {
        field: fields.bacteremia,
        cfield: fields.bacteremia,
        object: common.bacteremia.v6
      }
    ]
  }

  return [
    { field: fields.sheetNumber, special: 'numeric' },
    { field: fields.uf },
    { field: fields.birthdate, special: 'date' },
    { field: fields.sex },
    { field: fields.entrydate, special: 'date' },
    { field: fields.origin, cfield: fields.patientOrigin },
    { field: fields.immuno },
    { field: fields.antibio },
    { field: fields.birthWeight, special: 'numeric' },
    { field: fields.gestationalAge, special: 'numeric' },
    { field: fields.death, special: 'date' },
    { field: fields.mixManagment },
    ...fv[v]
  ]
}

export default {
  '2019': build('v1'),
  '2020': build('v2'),
  '2021': build('v3'),
  '2022': build('v3'),
  '2023': build('v4'),
  '2024': build('v5'),
  '2025': build('v6'),
  '2026': build('v6')
}
